
const variables = {
    SystemTitle: "SAF Partners system",
    AppBottomInfo: "SAF PARTNERS",
    ContactMail: "saf.dk",
    RedeemImage: "https://saf.dk/wp-content/uploads/2022/10/SAFPARTNERS-SORT.webp"
};

export default variables;
